'use client'

import { useMemo } from 'react'

import Icon, { IconName } from '@/components/atomic/icon'
import Tooltip from '@/components/atomic/tooltip'
import { AccountStatus } from '@/types/api/accounts'
import { cn } from '@/utils/shadcn/utils'

interface MomentStatusIconProps {
  status?: AccountStatus
  className?: string
}

export function MomentStatusIcon({ status, className }: MomentStatusIconProps) {
  const isAccountMomentStatusPaused =
    status === AccountStatus.Paused || status === null
  const iconName = useMemo(
    () =>
      isAccountMomentStatusPaused
        ? IconName.SignalSlashIcon
        : IconName.SignalIcon,
    [isAccountMomentStatusPaused],
  )

  return (
    <div className="flex items-center justify-center w-[16px]">
      <Tooltip
        side="top"
        simpleText={
          !status
            ? 'Account paused by Moment. Contact accounts@moment.com.'
            : undefined
        }
      >
        <div className="pointer-events-auto">
          <Icon
            iconName={iconName}
            outline={false}
            className={cn(
              'h-4 w-4',
              isAccountMomentStatusPaused ? 'text-red-500' : 'text-green-500',
              className,
            )}
          />
        </div>
      </Tooltip>
    </div>
  )
}
